import {gql} from '@apollo/client'

export const GET_BOTMAKER_VARIABLE_OPTIONS = gql`
  query GetBotmakerVariableOptions {
    botmakerVariableOptions {
      key
      label
      variables {
        value
        label
      }
    }
  }
`

export const GET_BOTMAKER_WHATSAPP_TEMPLATES = gql`
  query BotmakerWhatsappTemplates($state: String) {
    botmakerWhatsappTemplates(state: $state) {
      id
      name
      locale
      category
      status
      state
      createdAt
      updatedAt
      botName
      phoneLinesNumbers
      optInImage
      requesterEmail
      body
      footer
      allowedModules
      variableMapping
      isActive
      isArchived
    }
  }
`

export const GET_BOTMAKER_SETTINGS = gql`
  query GetBotmakerSettings {
    botmakerSettings {
      namespace
      botName
      phoneLineNumber
    }
  }
`
